export * from './lib/catalog-feature-shell.module';
export * from './lib/containers';
